import { Icon } from "@iconify-icon/react";
import { Modal, Radio } from "antd";
import Loader from "Components/Loader";
import { useGetCategoryQuery } from "hooks/CategoryManagement/useGetCategoryQuery";
import { useState } from "react";
import { SearchBox } from "./SearchBox";
import { useDebounce } from "hooks/useDebounce";

type AddProductsToCategoryModalProps = {
  selectedCategory: any | null;
  setSelectedCategory: (customer: any | null) => void;
  selectedCategoryName: any;
  setSelectedCategoryName: any;
};

const AddProductsToCategoryModal = ({
  selectedCategory,
  setSelectedCategory,
  selectedCategoryName,
  setSelectedCategoryName,
}: AddProductsToCategoryModalProps) => {
  const [search, setSearch] = useState("");

  const debouncedSearch = useDebounce(search);

  const [showCategoryModal, setShowCategoryModal] = useState<boolean>(false);

  const { data, isPending } = useGetCategoryQuery({
    search: debouncedSearch,
  });

  const handleCategoryChange = (e: any) => {
    const selectedId = e?.target?.value;
    const selectedCategoryObj = data?.data?.docs.find(
      (category: any) => category.id === selectedId
    );

    setSelectedCategory(selectedId);
    setSelectedCategoryName(selectedCategoryObj?.name);
    setShowCategoryModal(false);
  };

  return (
    <div>
      <button
        className="space-x-1 flex items-center outline-none border-none text-sm"
        onClick={() => setShowCategoryModal(true)}
      >
        {selectedCategoryName ? selectedCategoryName : "Select"}
        <Icon
          icon="iconamoon:arrow-down-2-duotone"
          width={20}
          color="#474747"
        />
      </button>
      <Modal
        title="Customer"
        open={showCategoryModal}
        className="max-w-[40rem] !w-full"
        footer={null}
      >
        <div className="w-full">
          <div className="w-full grid justify-between grid-cols-[1fr_auto] gap-x-2">
            <SearchBox
              value={search}
              onChange={setSearch}
              placeholder="Search Name, ID, Email Address"
              className="rounded-xl bg-[#F3F3F3]"
            />
          </div>
          {isPending && <Loader />}
          <Radio.Group
            value={selectedCategory}
            onChange={handleCategoryChange}
            className="w-full"
            name="customer"
          >
            <div className="max-h-[70vh] overflow-y-auto py-4 w-full">
              {data?.data?.docs.map((category: any) => (
                <Radio
                  key={category.id}
                  value={category.id}
                  className={`flex items-center space-x-2 border-b border-border px-4 py-3 ${
                    category.id === selectedCategory ? "bg-primary-light" : ""
                  }`}
                >
                  <div>
                    <b>{category?.name}</b>
                    <h3>{category?.description}</h3>
                  </div>
                </Radio>
              ))}
            </div>
          </Radio.Group>
        </div>
      </Modal>
    </div>
  );
};

export default AddProductsToCategoryModal;
